<div class="fx-admin-ib-detail">
  <fx-campaign-list
    [type]="'campaignIb'"
    [userId]="ib.userId">
  </fx-campaign-list>
  <fx-campaign-list
    [type]="'campaignUser'"
    [userId]="ib.userId">
  </fx-campaign-list>
  <fx-discretionary
    [userId]="ib.userId"
    [level]="ib.level"
  >
  </fx-discretionary>
</div>

